import { IPaymentAction, PAYMENT_INTENT_ID } from '../types'

export const setPaymentIntentId = (value: string | null): IPaymentAction => ({
  type: PAYMENT_INTENT_ID,
  value
})
